angular
	.module 'App.Module.Empty', []
	.config ($stateProvider) ->
		$stateProvider
			.state 'empty_state',
					url: '/not_found?newButtonSRef',
					views:
						main:
							templateUrl: '@app/empty-state/empty-state.view.html'
							controllerAs: 'vm'
							controller: ($stateParams) ->
								@newButtonSRef = $stateParams.newButtonSRef
